/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Actions/NavigationActionsCreator" />
import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { NavigationActionsHub } from "./NavigationActionsHub";


export class NavigationActionsCreator extends ActionCreatorBase {
    public initialize(_?: string): void {
        this._actions = ActionsHubManager.GetActionsHub<NavigationActionsHub>(NavigationActionsHub);
    }

    public static getKey(): string {
        return "endpoint-navigation-actionscreator";
    }

    public navigateBack(): void {
        this._actions.setNavigateBack.invoke();
    }

    public closePanel(): void {
        this._actions.setClosePanel.invoke();
    }

    private _actions: NavigationActionsHub;
}
